export default __webpack_public_path__ + "static/media/clean_support.466f0c77.svg";